export default __webpack_public_path__ + "3c1704fbce7cf1968ac3cfe68a6e471f.svg";